import { AuthorizationStatusEnum } from "@/app/services/authorizationService/getAuthorization";
import masks from "@/app/utils/masks";
import AuthorizationStatus from "@/view/components/CrefazClt/AuthorizationStatus";
import { Button } from "@/view/components/ui/button";
import {
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/view/components/ui/dialog";
import useAuthorizationModal from "./useAuthorizationModal";

interface AuthorizationModalProps {
  onClose: () => void;
}

export default function AuthorizationModal({
  onClose,
}: AuthorizationModalProps) {
  const {
    customerData,
    status,
    observation,
    // TODO: reenvio de SMS desabilitado temporariamente (em avaliacao)
    // isSendingSms,
    smsSent,
    // sendSms,
    handleSimulate,
  } = useAuthorizationModal();

  // TODO: reenvio de SMS desabilitado temporariamente (em avaliacao)
  // const isPending = status === AuthorizationStatusEnum.PENDING;
  const isAuthorized = status === AuthorizationStatusEnum.AUTHORIZED;

  return (
    <DialogContent className="sm:max-w-lg">
      <DialogHeader>
        <DialogTitle className="text-xl font-semibold text-black01">
          Autorização de consulta
        </DialogTitle>
        <DialogDescription className="!mt-0 text-base text-black04">
          {customerData?.name}
          {customerData?.cpf ? ` · ${masks.cpf(customerData.cpf)}` : ""}
        </DialogDescription>
      </DialogHeader>

      <AuthorizationStatus
        status={status}
        observation={observation}
        smsSent={smsSent}
        phone={customerData?.phone}
      />

      <div className="mt-6 flex justify-end gap-2">
        <Button
          type="button"
          variant="outline"
          onClick={onClose}
          className="w-[160px] rounded-full text-primary"
        >
          Fechar
        </Button>

        {/* TODO: reenvio de SMS desabilitado temporariamente (em avaliacao)
        {isPending && smsSent && (
          <Button
            type="button"
            className="w-[200px] rounded-full font-semibold text-white"
            onClick={sendSms}
            isLoading={isSendingSms}
            disabled={isSendingSms}
          >
            Reenviar SMS
          </Button>
        )} */}

        {isAuthorized && (
          <Button
            type="button"
            className="w-[160px] rounded-full font-semibold text-white"
            onClick={handleSimulate}
          >
            Simular
          </Button>
        )}
      </div>
    </DialogContent>
  );
}
